import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=a1fc22f0&scoped=true&"
var script = {}
import style0 from "./Home.vue?vue&type=style&index=0&id=a1fc22f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1fc22f0",
  null
  
)

export default component.exports